export const BUSINESS_ROLE_NOTIFICATION = 'businessRoleNotification';

// Long-running feature configurations
export const ENABLE_AUDIT_LOG = 'enableAuditLog';
export const ENABLE_IMPORT_EXPORT = 'enableImportExport';
export const ENABLE_SETTINGS = 'enableSettings';
export const ENABLE_DASHBOARD = 'enableDashboard';
export const ENABLE_CUSTOMERS = 'enableCustomers';
export const ENABLE_ORDERS = 'enableOrders';
export const ENABLE_MACHINE_LEARNING = 'enableMachineLearning';

export const SHARED_DEFAULT_SHORT_LIVED_FLAGS = {
  [BUSINESS_ROLE_NOTIFICATION]: false,
};

export const SHARED_DEFAULT_LONG_LIVED_FLAGS = {
  [ENABLE_AUDIT_LOG]: {
    value: false,
  },
  [ENABLE_IMPORT_EXPORT]: {
    value: false,
  },
  [ENABLE_SETTINGS]: {
    value: true,
  },
  [ENABLE_DASHBOARD]: {
    value: true,
  },
  [ENABLE_CUSTOMERS]: {
    value: true,
  },
  [ENABLE_ORDERS]: {
    value: true,
  },
  [ENABLE_MACHINE_LEARNING]: {
    value: true,
  },
};
